/**
 * 全站 Footer(_shared C-2)。多栏 + 底栏合规信息。
 * 文案对齐 design/home.html + docs/legal/external-dependencies.md（合规口径权威）。
 * 合规展示契约(_shared C-2「Footer 合规展示契约 ［✎010］」,Story 30-3 落地):
 *  1. 公司主体全称;2. ICP 备案号超链 beian.miit.gov.cn;3. 经营许可证号位「审核中」占位;
 *  4. 客服邮箱 support@tianhengjinyuan.com + 电话 19902065846(替换原假占位号);
 *  5. 可点击举报入口(PLATFORM 平台级投诉);6. 无死链(暂无真实页的链接已移除)。
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReportSheet } from '@/components/report/ReportSheet';
import { useAuthRequired } from '@/router/useAuthRequired';

const SUPPORT_EMAIL = 'support@tianhengjinyuan.com';
const SUPPORT_PHONE = '19902065846';

export function Footer() {
  const requireAuth = useAuthRequired();
  const [reportOpen, setReportOpen] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-cols">
        <div>
          <div className="brand mb-3">我行</div>
          <p className="muted">
            分享平台。
            <br />
            找人搭把手，顺手淘闲置。
          </p>
        </div>
        <div>
          <h4>帮助</h4>
          <Link to="/customer-service">联系客服</Link>
          <button
            type="button"
            className="footer-link-btn"
            onClick={() => requireAuth(() => setReportOpen(true))}
          >
            举报 / 投诉
          </button>
        </div>
        <div>
          <h4>法律</h4>
          <Link to="/agreement">用户协议</Link>
          <Link to="/privacy-policy">隐私政策</Link>
        </div>
      </div>
      <div className="footer-bar">
        <div className="footer-bar-inner">
          <span>© 2026 北京天衡晋远科技有限公司</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            京ICP备2026030527号-1
          </a>
          <span>增值电信业务经营许可证 京B2-审核中</span>
          <span className="muted">
            客服 <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> ·{' '}
            <a href={`tel:${SUPPORT_PHONE}`}>{SUPPORT_PHONE}</a>
          </span>
        </div>
      </div>

      {/* key 按开合重挂:每次打开都是干净实例,丢弃上次的在飞上传态(code-review Edge-Case #3)。 */}
      <ReportSheet
        key={reportOpen ? 'report-open' : 'report-closed'}
        open={reportOpen}
        targetType="PLATFORM"
        onClose={() => setReportOpen(false)}
      />
    </footer>
  );
}
